import React from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import Dialog from "rc-dialog";
import "rc-dialog/assets/bootstrap.css";
import moment from "moment";
import CircularProgressbar from "react-circular-progressbar";
import axios from "axios";
import loadImage from "blueimp-load-image";

moment.locale("nl");

class StudentPresent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.props.student,
      fileName: false,
      dialogOpen: false,
      studentsPresent: this.props.students,
      errorMessage: false
    };

    this.togglePresence = this.togglePresence.bind(this);
    this.handleEditLink = this.handleEditLink.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  togglePresence(e) {
    this.props.toggleStudentPresence(this.props.eventId, this.props.uuid);

    if (this.props.callbackParent) {
      this.props.callbackParent();
    }
  }

  handleFormSubmit(e) {
    e.preventDefault();

    let updateUser = {
      //event_role: this.refs.role.value,
      initials: this.refs.initials.value,
      first_name: this.refs.first_name.value,
      last_name_prefix: this.refs.last_name_prefix.value,
      last_name: this.refs.last_name.value,
      date_of_birth: this.refs.date_of_birth_year.value + "-" + this.refs.date_of_birth_month.value + "-" + this.refs.date_of_birth_day.value
    };

    axios
      .patch(`/v1/events/${this.props.params.eventId}/eventroles/${this.refs.role.value}/students/${this.props.uuid}/`, updateUser)
      .then((response) => {
        if (response.data) {
          this.props.fetchEvents();
          this.handleDialogClose();
        }
      })
      .catch((err) => {
        if (err.response.data !== undefined && err.response.data.person !== undefined) {
          this.setState({
            errorMessage: "Niet alle vereiste velden zijn juist ingevoerd, of er ging iets fout tijdens het verzenden naar de server."
          });
        } else {
          this.setState({
            errorMessage: err.response.data[0]
          });
        }
        console.warn("API Error: Adding student did not succeed", err);
      });
  }

  handleEditLink(e) {
    e.stopPropagation();
    this.setState({
      dialogOpen: true
    });
  }

  handleDialogClose() {
    this.setState({
      dialogOpen: false
    });
  }

  render() {
    var isActive = "";
    var isPresent = "Afwezig";

    if (this.props.students[this.props.eventId] !== undefined && this.props.students[this.props.eventId].includes(this.props.uuid)) {
      isActive = " active";
      isPresent = "Aanwezig";
    }

    var i = 1;
    var date_days = [];
    while (i <= 31) {
      date_days.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
      i++;
    }

    var i = 1;
    var date_months = [];
    while (i <= 12) {
      date_months.push(
        <option value={i} key={i}>
          {moment.months()[i - 1]}
        </option>
      );
      i++;
    }

    var i = 2017;
    var date_years = [];
    while (i >= 1900) {
      date_years.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
      i--;
    }

    var roles = [];
    this.props.roles.forEach((role, i) => {
      roles.push(
        <option value={role.uuid} key={role.uuid}>
          {role.name ? role.name : `Naamloze rol #${i + 1}`}
        </option>
      );
    });

    let errorMessage = "";
    if (this.state.errorMessage) {
      errorMessage = <div className="alert alert-warning">{this.state.errorMessage}</div>;
    }

    return (
      <div className={"student-present" + isActive} onClick={this.togglePresence}>
        <CircularProgressbar percentage={this.props.percentage} strokeWidth={6} textForPercentage={(pct) => ""} />
        <div className="student-name">
          {/* <button className="btn btn-sm btn-secondary" onClick={this.handleEditLink}>Bewerken</button> */}
          {this.props.student.full_name}
          {this.props.student.may_attend === false && (
            <span className={"error"}>
              <br />
              (Let op: e-learning nog niet behaald)
            </span>
          )}
          {this.props.student.may_attend === true && (
            <span className={"success"}>
              <br />
              (E-learning behaald)
            </span>
          )}
        </div>

        <Dialog
          title="Bewerken van een cursist"
          onClose={this.handleDialogClose}
          animation="fade"
          visible={this.state.dialogOpen}
          footer={[
            <button type="button" className="btn btn-secondary" key="close" onClick={this.handleDialogClose}>
              Annuleren
            </button>,
            <button type="button" className="btn btn-primary" key="save" onClick={this.handleFormSubmit}>
              Opslaan
            </button>
          ]}
        >
          <div className="form form-student">
            <form onSubmit={this.handleFormSubmit}>
              <div className="date-selector">
                <label>Geboortedatum van de cursist</label>
                <select className="form-control date-day" ref="date_of_birth_day" defaultValue={moment(this.props.student.date_of_birth).format("D")}>
                  {date_days}
                </select>
                <select className="form-control date-month" ref="date_of_birth_month" defaultValue={moment(this.props.student.date_of_birth).format("M")}>
                  {date_months}
                </select>
                <select className="form-control date-year" ref="date_of_birth_year" defaultValue={moment(this.props.student.date_of_birth).format("YYYY")}>
                  {date_years}
                </select>
              </div>

              {/*<div className="form-group">*/}
              {/*<label className="sr-only">NIBHV nummer</label>*/}
              {/*<input type="text" name="nibhv_number" ref="pro_crm_candidate_id" className="form-control" placeholder="NIBHV nummer" defaultValue={this.state.pro_crm_candidate_id} />*/}
              {/*</div>*/}

              <div className="form-group">
                <label className="sr-only">Voorletters</label>
                <input type="text" required name="initials" ref="initials" className="form-control" placeholder="Voorletters" defaultValue={this.state.initials} />
              </div>

              <div className="form-group">
                <label className="sr-only">Roepnaam</label>
                <input type="text" required name="first_name" ref="first_name" className="form-control" placeholder="Roepnaam" defaultValue={this.state.first_name} />
              </div>

              <div className="form-group">
                <label className="sr-only">Tussenvoegsel</label>
                <input
                  type="text"
                  name="last_name_prefix"
                  ref="last_name_prefix"
                  className="form-control"
                  placeholder="Tussenvoegsel"
                  defaultValue={this.state.last_name_prefix}
                />
              </div>

              <div className="form-group">
                <label className="sr-only">Achternaam</label>
                <input type="text" required name="last_name" ref="last_name" className="form-control" placeholder="Achternaam" defaultValue={this.state.last_name} />
              </div>

              <input type="hidden" name="role" ref="role" defaultValue={this.props.student_role.uuid} />

              {/*<div className="form-group">*/}
              {/*<select name="role" className="form-control" required ref="role" defaultValue={this.props.student_role.uuid}>*/}
              {/*roles*/}
              {/*</select>*/}
              {/*</div>*/}

              {errorMessage}
            </form>
          </div>
        </Dialog>
      </div>
    );
  }
}

StudentPresent.propTypes = {
  uuid: PropTypes.string.isRequired,
  eventId: PropTypes.string.isRequired,
  student: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  percentage: PropTypes.number
};

StudentPresent.defaultProps = {
  image: "",
  percentage: 0
};

export default StudentPresent;



// WEBPACK FOOTER //
// ./components/StudentPresent.js